import React, { useState } from 'react';
import { SearchIcon, FilterIcon, DownloadIcon, StarIcon, MoreVerticalIcon, FileTextIcon, XCircleIcon, CheckCircleIcon } from 'lucide-react';
const customerUsers = [{
  id: 'C-00923',
  name: 'sabrina',
  email: 'sabrina@sabrinajan.com',
  phone: '4166067607',
  creationDate: '11-04-2025',
  interest: 'BOTH',
  status: 'active',
  completionRate: 95,
  reliabilityScore: 4.8,
  cancellationRatio: 5,
  addresses: '-'
}, {
  id: 'C-00922',
  name: 'realtorkhanaasif',
  email: 'realtorkhanaasif@gmail.com',
  phone: '4167224615',
  creationDate: '11-04-2025',
  interest: 'BOTH',
  status: 'active',
  completionRate: 92,
  reliabilityScore: 4.6,
  cancellationRatio: 8,
  addresses: '-'
}, {
  id: 'C-00921',
  name: 'sumayamohammadi27',
  email: 'sumayamohammadi27@gmail.com',
  phone: '2041690962',
  creationDate: '10-31-2025',
  interest: 'BOTH',
  status: 'active',
  completionRate: 88,
  reliabilityScore: 4.4,
  cancellationRatio: 12,
  addresses: '-'
}, {
  id: 'C-00919',
  name: 'refills.paints_4q',
  email: 'refills.paints_4q@icloud.com',
  phone: '4164567391',
  creationDate: '10-27-2025',
  interest: 'BOTH',
  status: 'active',
  completionRate: 97,
  reliabilityScore: 4.9,
  cancellationRatio: 3,
  addresses: '-'
}, {
  id: 'C-00918',
  name: 'sheikhfck248',
  email: 'sheikhfck248@gmail.com',
  phone: '+23276167195',
  creationDate: '10-24-2025',
  interest: 'BOTH',
  status: 'active',
  completionRate: 85,
  reliabilityScore: 4.2,
  cancellationRatio: 15,
  addresses: '-'
}, {
  id: 'C-00915',
  name: 'david',
  email: 'david@rinver.ca',
  phone: '+16479170188',
  creationDate: '10-22-2025',
  interest: 'BOTH',
  status: 'active',
  completionRate: 93,
  reliabilityScore: 4.7,
  cancellationRatio: 7,
  addresses: '-'
}, {
  id: 'C-00914',
  name: 'saharnajam79',
  email: 'saharnajam79@gmail.com',
  phone: '3083382949',
  creationDate: '10-20-2025',
  interest: 'BOTH',
  status: 'active',
  completionRate: 90,
  reliabilityScore: 4.5,
  cancellationRatio: 10,
  addresses: '-'
}, {
  id: 'C-00913',
  name: 'www.tukamuhebwaalvin1010',
  email: 'www.tukamuhebwaalvin1010@gmail.com',
  phone: '+256766083596',
  creationDate: '10-19-2025',
  interest: 'BOTH',
  status: 'active',
  completionRate: 78,
  reliabilityScore: 3.9,
  cancellationRatio: 22,
  addresses: '-'
}];
const proUsers = [{
  id: 'P-00924',
  name: 'Arik Elva',
  email: 'arik2010@live.ca',
  phone: '+14168711380',
  creationDate: '11-12-2025',
  status: 'active',
  addresses: '3390 Keele St #618, North York, ON M3J 1L6, Canada',
  services: 'Electrical, Plumbing, Handyman Services, Painting Services, Home Improvement and Renovations!',
  trusted: true,
  documentVerified: true,
  stripeConnected: false
}, {
  id: 'P-00911',
  name: 'Josee Indovino-Arnodio',
  email: 'xteempropertycleangtia@hotmail.com',
  phone: '+14168058713',
  creationDate: '10-15-2025',
  status: 'active',
  addresses: '38 Poromeade Crescent, Whitchurch-Stouffville, ON L4A 0E2, Canada',
  services: 'Home Cleaning Services',
  trusted: true,
  documentVerified: true,
  stripeConnected: true
}, {
  id: 'P-00910',
  name: 'Elizabeth',
  email: 'mjerenovation2023@gmail.com',
  phone: '+14169185917',
  creationDate: '10-15-2025',
  status: 'active',
  addresses: '38 Saffron St, Markham, ON L6E 1L3, Canada',
  services: 'Painting Services, Home Cleaning Services, Home Improvement and Renovations!',
  trusted: true,
  documentVerified: true,
  stripeConnected: false
}, {
  id: 'P-00906',
  name: 'Charlene Torres',
  email: 'ctorresvazque@gmail.com',
  phone: '+18022892808',
  creationDate: '10-07-2025',
  status: 'active',
  addresses: '15 Green Mountain Rd E, Stoney Creek, ON L8J 2W4, Canada',
  services: 'Mortgage Financing',
  trusted: false,
  documentVerified: false,
  stripeConnected: false
}, {
  id: 'P-00896',
  name: 'Test',
  email: 'rjcornelio22@gmail.com',
  phone: '+14161234567',
  creationDate: '09-24-2025',
  status: 'active',
  addresses: '49 Bogert Ave, North York, ON M2N 1K4, Canada',
  services: 'Carpet Cleaning, Painting Services, Appliance Repair',
  trusted: true,
  documentVerified: true,
  stripeConnected: true
}, {
  id: 'P-00881',
  name: 'Taras Zadorozhnyy',
  email: 'info@canadaappliancerepair.ca',
  phone: '+14168875839',
  creationDate: '09-18-2025',
  status: 'active',
  addresses: '325 Bogert Ave Unit L2, North York, ON M2N 1L8, Canada',
  services: 'Appliance Repair',
  trusted: true,
  documentVerified: true,
  stripeConnected: true
}, {
  id: 'P-00879',
  name: 'Olga',
  email: 'olgamailer@hotmail.com',
  phone: '+16478386007',
  creationDate: '09-17-2025',
  status: 'active',
  addresses: '70 Revelstoke Crescent, Richmond Hill, ON L4B 4T4, Canada',
  services: 'Painting Services',
  trusted: false,
  documentVerified: false,
  stripeConnected: true
}];
export const UsersPage = () => {
  const [activeTab, setActiveTab] = useState('customer');
  const [searchQuery, setSearchQuery] = useState('');
  const currentUsers = activeTab === 'customer' ? customerUsers : proUsers;
  return <div className="p-6" data-id="element-1064">
      <div className="mb-6" data-id="element-1065">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-1066">Users</h1>
        <p className="text-sm text-gray-500 mt-1" data-id="element-1067">
          Manage and monitor user performance metrics
        </p>
      </div>
      <div className="bg-white rounded-lg shadow border border-gray-100" data-id="element-1068">
        <div className="p-4 border-b border-gray-200" data-id="element-1069">
          <div className="flex items-center justify-between mb-4" data-id="element-1070">
            <div className="flex items-center space-x-2" data-id="element-1071">
              <button className="p-2 rounded-md hover:bg-gray-100" data-id="element-1072">
                <FilterIcon size={18} className="text-gray-500" data-id="element-1073" />
              </button>
              <div className="relative" data-id="element-1074">
                <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-1075" />
                <input type="text" placeholder="Search for something..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="pl-10 pr-4 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 w-80" data-id="element-1076" />
              </div>
              <select className="px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500" data-id="element-1077">
                <option data-id="element-1078">Status</option>
                <option data-id="element-1079">Active</option>
                <option data-id="element-1080">Inactive</option>
              </select>
            </div>
            <button className="flex items-center px-4 py-2 bg-blue-50 text-blue-600 rounded-md text-sm font-medium hover:bg-blue-100" data-id="element-1081">
              <DownloadIcon size={16} className="mr-2" data-id="element-1082" />
              Export
            </button>
          </div>
          <div className="flex space-x-1 border-b border-gray-200" data-id="element-1083">
            <TabButton active={activeTab === 'customer'} onClick={() => setActiveTab('customer')} data-id="element-1084">
              Customer
            </TabButton>
            <TabButton active={activeTab === 'pro'} onClick={() => setActiveTab('pro')} data-id="element-1085">
              Pro
            </TabButton>
            <TabButton active={activeTab === 'both'} onClick={() => setActiveTab('both')} data-id="element-1086">
              Pro with customer profile
            </TabButton>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-1087">
          <table className="w-full" data-id="element-1088">
            <thead className="bg-gray-50 border-b border-gray-200" data-id="element-1089">
              <tr data-id="element-1090">
                <th className="px-4 py-3 text-left" data-id="element-1091">
                  <input type="checkbox" className="rounded" data-id="element-1092" />
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1093">
                  #
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1094">
                  Name
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1095">
                  Status
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1096">
                  Action
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1097">
                  Email
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1098">
                  Phone
                </th>
                {activeTab === 'customer' && <>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1099">
                      Creation Date
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1100">
                      Interest
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1101">
                      Completion Rate
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1102">
                      Reliability
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1103">
                      Cancellation
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1104">
                      Addresses
                    </th>
                  </>}
                {(activeTab === 'pro' || activeTab === 'both') && <>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1105">
                      Addresses
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1106">
                      Services
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1107">
                      Creation date
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1108">
                      Trusted
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1109">
                      Document
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1110">
                      Stripe Status
                    </th>
                  </>}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-1111">
              {currentUsers.map(user => <UserRow key={user.id} user={user} userType={activeTab} data-id="element-1112" />)}
            </tbody>
          </table>
        </div>
        <div className="px-4 py-3 border-t border-gray-200 flex items-center justify-between" data-id="element-1113">
          <div className="text-sm text-gray-500" data-id="element-1114">1-8 of 566</div>
          <div className="flex items-center space-x-2" data-id="element-1115">
            <button className="px-3 py-1 border border-gray-300 rounded text-sm hover:bg-gray-50" data-id="element-1116">
              Previous
            </button>
            <button className="px-3 py-1 border border-gray-300 rounded text-sm hover:bg-gray-50" data-id="element-1117">
              Next
            </button>
            <select className="px-2 py-1 border border-gray-300 rounded text-sm" data-id="element-1118">
              <option data-id="element-1119">25 / page</option>
              <option data-id="element-1120">50 / page</option>
              <option data-id="element-1121">100 / page</option>
            </select>
          </div>
        </div>
      </div>
    </div>;
};
const TabButton = ({
  active,
  children,
  onClick
}) => {
  return <button onClick={onClick} className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${active ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`} data-id="element-1122">
      {children}
    </button>;
};
const UserRow = ({
  user,
  userType
}) => {
  const [showActionMenu, setShowActionMenu] = useState(false);
  const [trusted, setTrusted] = useState(user.trusted || false);
  const getCompletionColor = rate => {
    if (rate >= 90) return 'text-green-600 bg-green-50';
    if (rate >= 80) return 'text-yellow-600 bg-yellow-50';
    return 'text-red-600 bg-red-50';
  };
  const getReliabilityColor = score => {
    if (score >= 4.5) return 'text-green-600 bg-green-50';
    if (score >= 4.0) return 'text-yellow-600 bg-yellow-50';
    return 'text-red-600 bg-red-50';
  };
  const getCancellationColor = ratio => {
    if (ratio <= 10) return 'text-green-600 bg-green-50';
    if (ratio <= 15) return 'text-yellow-600 bg-yellow-50';
    return 'text-red-600 bg-red-50';
  };
  return <tr className="hover:bg-gray-50" data-id="element-1123">
      <td className="px-4 py-3" data-id="element-1124">
        <input type="checkbox" className="rounded" data-id="element-1125" />
      </td>
      <td className="px-4 py-3 text-sm text-gray-900" data-id="element-1126">{user.id}</td>
      <td className="px-4 py-3" data-id="element-1127">
        <div className="flex items-center" data-id="element-1128">
          <div className="h-8 w-8 rounded bg-gray-200 flex items-center justify-center mr-2" data-id="element-1129">
            <span className="text-xs text-gray-600" data-id="element-1130">
              {user.name.charAt(0).toUpperCase()}
            </span>
          </div>
          <span className="text-sm font-medium text-gray-900" data-id="element-1131">{user.name}</span>
        </div>
      </td>
      <td className="px-4 py-3" data-id="element-1132">
        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700" data-id="element-1133">
          <span className="w-1.5 h-1.5 rounded-full bg-green-500 mr-1.5" data-id="element-1134"></span>
          Active
        </span>
      </td>
      <td className="px-4 py-3" data-id="element-1135">
        <div className="relative" data-id="element-1136">
          <button onClick={() => setShowActionMenu(!showActionMenu)} className="p-1 hover:bg-gray-100 rounded" data-id="element-1137">
            <MoreVerticalIcon size={16} className="text-gray-500" data-id="element-1138" />
          </button>
          {showActionMenu && <div className="absolute left-0 mt-1 w-32 bg-white rounded-md shadow-lg border border-gray-200 z-10" data-id="element-1139">
              <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" data-id="element-1140">
                View
              </button>
              <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" data-id="element-1141">
                Deactivate
              </button>
              <button className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-50" data-id="element-1142">
                Delete
              </button>
            </div>}
        </div>
      </td>
      <td className="px-4 py-3 text-sm text-gray-500" data-id="element-1143">{user.email}</td>
      <td className="px-4 py-3 text-sm text-gray-500" data-id="element-1144">{user.phone}</td>
      {userType === 'customer' && <>
          <td className="px-4 py-3 text-sm text-gray-500" data-id="element-1145">
            {user.creationDate}
          </td>
          <td className="px-4 py-3 text-sm text-gray-500" data-id="element-1146">{user.interest}</td>
          <td className="px-4 py-3" data-id="element-1147">
            <span className={`inline-flex px-2 py-1 rounded-md text-xs font-medium ${getCompletionColor(user.completionRate)}`} data-id="element-1148">
              {user.completionRate}%
            </span>
          </td>
          <td className="px-4 py-3" data-id="element-1149">
            <div className="flex items-center" data-id="element-1150">
              <StarIcon size={14} className="text-yellow-500 mr-1" data-id="element-1151" />
              <span className={`inline-flex px-2 py-1 rounded-md text-xs font-medium ${getReliabilityColor(user.reliabilityScore)}`} data-id="element-1152">
                {user.reliabilityScore}
              </span>
            </div>
          </td>
          <td className="px-4 py-3" data-id="element-1153">
            <span className={`inline-flex px-2 py-1 rounded-md text-xs font-medium ${getCancellationColor(user.cancellationRatio)}`} data-id="element-1154">
              {user.cancellationRatio}%
            </span>
          </td>
          <td className="px-4 py-3 text-sm text-gray-500" data-id="element-1155">{user.addresses}</td>
        </>}
      {(userType === 'pro' || userType === 'both') && <>
          <td className="px-4 py-3 text-sm text-gray-500 max-w-xs" data-id="element-1156">
            {user.addresses}
          </td>
          <td className="px-4 py-3 text-sm text-gray-500 max-w-md" data-id="element-1157">
            {user.services}
          </td>
          <td className="px-4 py-3 text-sm text-gray-500" data-id="element-1158">
            {user.creationDate}
          </td>
          <td className="px-4 py-3" data-id="element-1159">
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-1160">
              <input type="checkbox" checked={trusted} onChange={() => setTrusted(!trusted)} className="sr-only peer" data-id="element-1161" />
              <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600" data-id="element-1162"></div>
            </label>
          </td>
          <td className="px-4 py-3" data-id="element-1163">
            {user.documentVerified ? <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-blue-600 text-white" data-id="element-1164">
                <FileTextIcon size={12} className="mr-1" data-id="element-1165" />
                Verified
              </span> : <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-gray-300 text-gray-700" data-id="element-1166">
                <FileTextIcon size={12} className="mr-1" data-id="element-1167" />
                Unverified
              </span>}
          </td>
          <td className="px-4 py-3" data-id="element-1168">
            {user.stripeConnected ? <CheckCircleIcon size={20} className="text-green-500" data-id="element-1169" /> : <XCircleIcon size={20} className="text-red-500" data-id="element-1170" />}
          </td>
        </>}
    </tr>;
};